/**
 * De ingang van `sdk/v1.js` — de bundel die een klant met één `<script>` op
 * zijn pagina zet (structuurplan §5.2 stap 1, §8.2).
 *
 * Eén taak: het element registreren zodra het script draait. Dit bestand is
 * daarom het ENIGE in de SDK met een neveneffect bij import; al het andere is
 * puur, zodat een npm-consument (`@mark2form/sdk`) zelf het moment kiest.
 *
 * ── WAAROM DEZE INGANG IN `packages/embed` STAAT EN DE BRON IN `packages/sdk`
 * De SDK-bron (het element, de parser, de publieke exports) woont sinds de
 * npm-publicatie in `@mark2form/sdk`. Het BESTAND `v1.js` wordt nog hier
 * gebouwd, op `packages/embed/dist/sdk/v1.js`, omdat het portaal het precies
 * daar leest (`apps/portal/src/lib/sdk-bundel.ts`, via zijn dependency op
 * `@mark2form/embed`). Die weg verleggen is een wijziging in het portaal en
 * krijgt een eigen PR. Tot dan: één bron, één IIFE-build, hier.
 *
 * De REGISTRATIE hangt niet aan `document.currentScript`: het script mag
 * `async`, `defer` of via een tagmanager geladen worden, en
 * `customElements.define` werkt in alle drie de gevallen — een element dat al
 * in de HTML staat wordt met terugwerkende kracht geüpgraded. Dat is precies
 * waarom §5.2 een custom element voorschrijft en geen `document.write`-loader.
 *
 * K33: `document.currentScript` wordt alleen gelezen voor één STANDAARD — het
 * portaal waar de verificatie-ping heen gaat is het portaal dat dit script
 * serveerde (een preview, een tweede merk), niet altijd productie. Ontbreekt
 * hij (een tagmanager, een module-script), dan blijft
 * `STANDAARD_PORTAAL_BASIS` staan; `portal="…"` op het element wint altijd.
 */

import { registreerCustomElement, zetPortaalBasis } from "@mark2form/sdk";

// K33 — de standaard voor de verify-ping: het portaal dat dit script serveerde.
// Leest alleen een STANDAARD; `portal="…"` op het element wint altijd.
const huidig = typeof document !== "undefined" ? document.currentScript : null;
// (`typeof HTMLScriptElement` eerst: zonder DOM is `huidig` null, maar zou
// `instanceof` zelf al een ReferenceError geven.)
if (typeof HTMLScriptElement !== "undefined" && huidig instanceof HTMLScriptElement && huidig.src) {
  try {
    const url = new URL(huidig.src);
    if (/\/sdk\/v\d+\.js$/.test(url.pathname)) zetPortaalBasis(url.origin);
  } catch {
    /* geen bruikbare bron: STANDAARD_PORTAAL_BASIS blijft */
  }
}

registreerCustomElement();

// De publieke API ook op `window`, zodat een klantpagina zonder bundelaar er
// toch bij kan (`Mark2Form.zetEmbedBasis('https://upgraded.tools')` vóór het
// element in de DOM komt). Eén globale naam, geen losse functies.
export {
  huidigeEmbedBasis,
  huidigePortaalBasis,
  klemEmbedHoogte,
  parseEmbedBericht,
  registreerCustomElement,
  SDK_EVENTS,
  SDK_FOUTCODES,
  STANDAARD_EMBED_BASIS,
  STANDAARD_PORTAAL_BASIS,
  zetEmbedBasis,
  zetPortaalBasis,
} from "@mark2form/sdk";
